// Scripts for formatting the WordPress pagination ellipse and removing empty links in the list
var pagination = $('.wex-pagination');
if (pagination && pagination.length > 0) {
  var emptyLinks = $('.wex-pagination a[href="#"]'),
    ellipse = $('.wex-pagination a[href="#"]')[0];

  $(ellipse).parent().replaceWith('<li class="ellipsis"></li>');
  if(emptyLinks && emptyLinks.length !== 0) emptyLinks.remove();
  if(ellipse && ellipse.length !== 0) ellipse.remove();
}